module.exports = __webpack_public_path__ + "img/57_9.82b77123.png";